import {
  Box,
  Divider,
  FormControl,
  FormLabel,
  Switch,
  Typography,
} from '@mui/material'
import { Modal } from 'components/common/modal'
import { TextField } from 'components/textField'
import { observer } from 'mobx-react'
import { Step } from 'models'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface StepSettingsModalProps {
  isOpen:      boolean,
  currentStep: Step,
  canEdit:     boolean,
  onClose:     () => void,
}

export const StepSettingsModal: React.FC<StepSettingsModalProps> = observer(({ isOpen, onClose, currentStep, canEdit }) => {
  const { t } = useTranslation()
  const [mandatory, setMandatory] = useState(currentStep.mandatory)

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Typography variant='h4'>{t('editor_step_settings_title')}</Typography>

      <Box pb={3}>
        <FormControl
          sx     = {{ display: 'flex', flexDirection: 'column' }}
          margin = 'normal'
        >
          <FormLabel>{t('main_title')}</FormLabel>
          <TextField
            hiddenLabel
            debounced
            delay    = {300}
            variant  = 'outlined'
            value    = {currentStep.title}
            onChange = {(e) => currentStep.set('title', e.target.value, true)}
          />
        </FormControl>
        <FormControl
          sx     = {{ display: 'flex', flexDirection: 'column' }}
          margin = 'normal'
        >
          <FormLabel>{t('sidebar_title')}</FormLabel>
          <TextField
            hiddenLabel
            debounced
            delay    = {300}
            variant  = 'outlined'
            value    = {currentStep.name}
            onChange = {(e) => currentStep.set('name', e.target.value, true)}
          />
        </FormControl>
      </Box>
      <Divider />
      <Box
        display        = 'flex'
        justifyContent = 'space-between'
        alignItems     = 'center'
        pt             = {3}
      >
        <FormLabel>{t('settings_make_step_mandatory')}</FormLabel>
        <Switch
          disabled = {!canEdit || currentStep.isSub}
          checked  = {mandatory}
          name     = 'mandatory'
          onChange = {() => {
            setMandatory(!mandatory)
            currentStep.set('mandatory', !currentStep.mandatory, true)
          }}
        />
      </Box>
    </Modal>
  );
});
